export const initialValuesRule = {
  positionId: '',
  constraints: {
    maxWeeklyHours: '',
    minRestHoursBetweenShifts: '',
    maxConsecutiveWorkDays: '',
    allowRotatingShifts: '',
  },
};
